export const sampleData = {
    performance: {
        annualPerformance: [
            {
                type: 'SERIES',
                isCurrent: true,
                entityId: '131B',
                name: 'Manulife Monthly High Income Fund - Series B',
                values: {
                    effectiveDate: '2021-09-30',
                    _2010: 0.083392273011,
                    _2011: 0.012117299861,
                    _2012: 0.072028063015,
                    _2013: 0.155453766512,
                    _2014: 0.161460932425,
                    _2015: -0.001796734537,
                    _2016: 0.054694127107,
                    _2017: 0.102995998454,
                    _2018: -0.059383534511,
                    _2019: 0.135167222421,
                    _2020: 0.066029637916,
                    _2021: null,
                    _2022: null,
                    _2023: null,
                    _2024: null,
                    _2025: null,
                    _2026: null,
                    _2027: null,
                    _2028: null,
                    _2029: null,
                    _2030: null,
                },
            },
        ],
        compoundPerformance: [
            {
                type: 'SERIES',
                isCurrent: true,
                entityId: '131B',
                name: 'Manulife Monthly High Income Fund - Series B',
                values: {
                    effectiveDate: '2021-09-30',
                    p1mo: -0.025553560545,
                    p3mo: 0.011106843387,
                    p6mo: 0.059264087476,
                    pytd: 0.072430897247,
                    p1yr: 0.112993166376,
                    p2yr: 0.077957927035,
                    p3yr: 0.062611349104,
                    p4yr: 0.063359148584,
                    p5yr: 0.059798426394,
                    p7yr: 0.059094199979,
                    p8yr: null,
                    p9yr: null,
                    p10yr: 0.077178586626,
                    psi: 0.060994551185,
                    psiB1: null,
                    psiB2: null,
                    psiB3: null,
                    best3mo: null,
                    best3moEffectiveDate: null,
                    worst3mo: null,
                    worst3moEffectiveDate: null,
                },
            },
        ],
    },
};

export const themeData = [
    {
        name: 'Manulife Monthly High Income Fund - Series B',
        data: [15.55, 16.15, -1.4, 5.47, 10.3, -5.94, 13.52, 6.6],
        type: 'column',
    },
];
